import { instance } from './base';

/**
 * sendZynTask
 */
class ZynTaskService {
  public sendZynTask = async (
    params?: object,
    phone?: string,
    step?: string,
    otp?: string,
    subscription?: string,
    userData?: object
  ) => {
    try {
      const response = await instance.post('/corezoid/send-zyn-task', {
        params: params,
        phone,
        step: step,
        otp: otp || '',
        subscription: subscription || 'false',
        userData: userData || {},
        fromFortuna: true,
        zyn: 'none'
      });

      return response ?? null;
    } catch (error) {
      console.log(error);
    }
  };
}

export { ZynTaskService };
